import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState, memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFunctions } from 'system/pages/functions/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersGroupProps {
  filterFunctionsForm: FormikProps<FiltersFunctions>;
}

const FilterFunctionsComponent = ({
  filterFunctionsForm,
}: FiltersGroupProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-groups-content"
        id="panel-groups-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterFunctionsForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterFunctionsForm.values.code}
                onChange={filterFunctionsForm.handleChange}
                error={filterFunctionsForm.touched.code && Boolean(filterFunctionsForm.errors.code)}
                helperText={filterFunctionsForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione"
                label="Descrizione"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterFunctionsForm.values.description}
                onChange={filterFunctionsForm.handleChange}
                error={
                  filterFunctionsForm.touched.description &&
                  Boolean(filterFunctionsForm.errors.description)
                }
                helperText={filterFunctionsForm.errors.description}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Entità"
                label="Entità"
                id="entity"
                name="entity"
                fullWidth
                type="text"
                variant="outlined"
                value={filterFunctionsForm.values.entity}
                onChange={filterFunctionsForm.handleChange}
                error={
                  filterFunctionsForm.touched.entity && Boolean(filterFunctionsForm.errors.entity)
                }
                helperText={filterFunctionsForm.errors.entity}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterFunctionsForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterFunctionsComponent.displayName = 'Filters Functions';

const FilterFunctions = memo(FilterFunctionsComponent);

export default FilterFunctions;
